import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-funktionsbereich-pruefbericht-pdf';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungFunktionsbereichPruefberichtPdfEffects {

    VeranstaltungFunktionsbereichPruefberichtPdf$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_FUNKTIONSBEREICH_PRUEFBERICHT_PDF),
        mergeMap((x: ac.GetVeranstaltungFunktionsbereichPruefberichtPdfAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungFunktionsbereichPruefberichtPdf(x.veranstaltung_id, x.funktionsbereich_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungFunktionsbereichPruefberichtPdfErfolgreichAction(x.veranstaltung_id, x.funktionsbereich_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungFunktionsbereichPruefberichtPdfFehlerAction(error, x.veranstaltung_id, x.funktionsbereich_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenQueryService);
        }
        return this.service;
    }
}
